export default __webpack_public_path__ + "static/applet-18-set-1-9f056ebb9bcf958c7ba4ec8aaa757dde.webp";